import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';

export type RemitReportingChannel = 'SUBMISSION_TO_ACER' | 'EMAIL';

export type RemitReportingSubscriptionInfo = {
    orgId: string;
    active: boolean;
    channels: RemitReportingChannel[];
    issuerEic?: string;
    email?: string;
    validFrom?: string; // ISO-date with TZ
};

export class RemitReportingService {
    async secondaryRemitReportingSettings() {
        if (!config.remitReporting) return;
        try {
            const response =
                await reactShell.axios.request<RemitReportingSubscriptionInfo>({
                    url: `${config.remitReporting}/api/platform/remit-reporting-settings/secondary`
                });

            return response.data;
        } catch (e) {
            if (
                e &&
                e.name === 'AxiosError' &&
                e.response &&
                (e.response.status === 401 || e.response.status === 403)
            )
                return;
            console.error(e);
        }
    }
}

angular.module('app').service('remitReportingService', RemitReportingService);
